import { ActionIcon, Flex, TitleProps } from "@mantine/core";
import { IconAlertTriangle, IconHistory } from "@tabler/icons-react";

import { Title } from "components";

export type SectionTitleIndicatorType = "warning" | "history";

interface SectionTitleProps extends TitleProps {
  label: string;
  isBankCredit?: boolean;
  hasWarning?: boolean;
  onWarningClick?: () => void;
  indicatorType?: SectionTitleIndicatorType;
}

const SectionTitle = ({
  label,
  isBankCredit = false,
  hasWarning = false,
  onWarningClick,
  indicatorType = "warning",
  ...rest
}: SectionTitleProps) => {
  const color = isBankCredit ? "#B046AC" : "var(--mantine-color-primary-6)";
  const indicatorActionColor = "orange";
  const indicatorActionVariant = "subtle";
  const indicatorStandaloneColor = "orange";
  const indicatorIcon =
    indicatorType === "history" ? (
      <IconHistory size={17} style={{ flexShrink: 0 }} />
    ) : (
      <IconAlertTriangle size={17} style={{ flexShrink: 0 }} />
    );

  return (
    <Flex align="center" gap={6} mt={"sm"} mb={"sm"}>
      <Title order={5} mt={0} mb={0} c={color} {...rest}>
        {label}
      </Title>
      {hasWarning &&
        (onWarningClick ? (
          <ActionIcon
            variant={indicatorActionVariant}
            color={indicatorActionColor}
            size="sm"
            onClick={onWarningClick}
            aria-label={label}
          >
            {indicatorIcon}
          </ActionIcon>
        ) : (
          <span style={{ display: "inline-flex", color: indicatorStandaloneColor }}>
            {indicatorIcon}
          </span>
        ))}
    </Flex>
  );
};

export default SectionTitle;
